export default __webpack_public_path__ + "static/media/pj-jogo-velha.cd1a0209.png";